export const tips: string[] = [
  'dashboard.tips.createStudyPlan',
  'dashboard.tips.reviewNotesDaily',
  'dashboard.tips.activeRecall',
  'dashboard.tips.useFlashcards',
  'dashboard.tips.takeRegularBreaks',
  'dashboard.tips.teachSomeoneElse',
  'dashboard.tips.summarizeReadings',
  'dashboard.tips.groupStudySessions',
  'dashboard.tips.setSpecificGoals',
  'dashboard.tips.organizeStudySpace',
  'dashboard.tips.pomodoroTechnique',
  'dashboard.tips.reviewPastExams',
  'dashboard.tips.explainConceptsAloud',
  'dashboard.tips.createMindMaps',
  'dashboard.tips.practiceProblems',
  'dashboard.tips.selfTesting',
  'dashboard.tips.sleepWell',
  'dashboard.tips.hydrateForFocus',
  'dashboard.tips.manageTimeEffectively',
  'dashboard.tips.minimizeDistractions',
  'dashboard.tips.scheduleBreaks',
  'dashboard.tips.askQuestions',
  'dashboard.tips.useMnemonics',
  'dashboard.tips.setDeadlines',
  'dashboard.tips.trackProgress'
];
